import React, { Component } from "react"
import MiniSearch from "../../lib/minisearch"

import allData from "../../sdata/all.json"
// import fqa from "../../sdata/fqa.json"
// import guide from "../../sdata/guide.json"
// import intro from "../../sdata/intro.json"
// import posts from "../../sdata/posts.json"
// import advance from "../../sdata/advance.json"
import st from "./css/search.module.scss"
import Svg from "./svg"
import { Link } from "gatsby"
import classNames from "classnames"
import {
  buildHighlightParts,
  normalizeSearchText,
  sanitizeSearchQuery,
} from "../utils/search"
// import { Highlight } from "instantsearch.js/es/helpers/components"

// You can set the default search options upon initialization
const defaultOpt = {
  fields: ["title", "content", "desc", "tags"],
  searchOptions: {
    boost: { title: 5, desc: 2 },
    fuzzy: 0,
  },
}
// const sdata = {
//   fqa,
//   guide,
//   intro,
//   posts,
//   advance,
// }
const catMap = {
  posts: "帮助文档",
  guide: "使用指南",
  fqa: "常见问题",
  intro: "产品介绍",
  advance: "酷课优势",
}
const allDataById = allData.reduce((prev, item) => {
  prev[item.id] = item
  return prev
}, {})

export default class Search extends Component {
  state = {
    value: "",
    result: [],
  }
  componentDidMount() {
    this.initSearch()
    if (this.props.topBar) {
      this.refs.searchInput.addEventListener("keydown", e => {
        if (e.keyCode === 13) {
          this.refs.searchInput.blur()
        }
      })
    }
  }
  initSearch = () => {
    const { searchOpt = defaultOpt } = this.props
    this[`miniSearch_all`] = new MiniSearch(searchOpt)
    this[`miniSearch_all`].addAll(allData)
  }
  search = value => {
    const safeValue = sanitizeSearchQuery(value)

    if (!safeValue.length) {
      this.setState({
        result: [],
      })
      return
    }
    const result = this[`miniSearch_all`].search(safeValue)
    const limit = 9
    this.setState({
      result: result.slice(0, limit),
    })
  }
  hdSearch = e => {
    const value = (e.target.value || "").trim()
    this.setState({ value })
    this.search(value)
  }
  hdBlur = e => {
    setTimeout(() => {
      this.setState({
        value: "",
        result: [],
      })
    }, 300)
  }

  render() {
    const { value, result } = this.state
    const { navBar, topBar, orinCat } = this.props
    return (
      <div
        className={classNames(
          st.wrapper,
          { [st.navBar]: navBar },
          { [st.topBar]: topBar }
        )}
      >
        <div className={st.inputWrap}>
          <input
            ref="searchInput"
            type="text"
            className={st.input}
            onChange={this.hdSearch}
            onBlur={topBar ? undefined : this.hdBlur}
            value={value}
            placeholder={`搜索关键词`}
          />
          {!!value.length ? (
            <Svg
              id="close"
              svgClass={st.icon}
              style={{ cursor: "pointer" }}
              onClick={this.hdBlur}
            />
          ) : (
            <Svg id="search" svgClass={st.icon} />
          )}
        </div>
        {value.length > 0 && (
          <div className={st.result}>
            {result.length > 0 ? (
              result.map((v, i) => {
                const item = allDataById[v.id]
                if (!item) {
                  return null
                }
                const { id, cat, title, content, desc, tags } = item
                const hasDesc = v.score.fields.includes("desc")
                const hasTags = v.score.fields.includes("tags")
                const hasCont = v.score.fields.includes("content")
                const isGuidePage =
                  cat === "guide" && window.location.pathname === "/"
                // console.log(isGuidePage, window.location.pathname)
                const linkEl = (
                  <Highlight
                    abort={!v.score.fields.includes("title")}
                    query={v.query}
                    topBar={topBar}
                    text={title}
                    color="#4d3800"
                  />
                )
                return (
                  <div className={st.raw} key={v.id}>
                    <div className={st.cat}>{catMap[cat]}</div>
                    <div className={st.list} key={id}>
                      <div
                        className={st.title}
                        onClick={topBar ? this.hdBlur : undefined}
                      >
                        {isGuidePage ? (
                          <a href={id}>{linkEl}</a>
                        ) : (
                          <Link to={id}>{linkEl}</Link>
                        )}
                      </div>
                      {hasTags && (
                        <div className={st.tags}>
                          {
                            <Highlight
                              query={v.query}
                              text={tags}
                              topBar={topBar}
                            />
                          }
                        </div>
                      )}
                      {hasDesc && (
                        <div className={st.tags}>
                          {
                            <Highlight
                              query={v.query}
                              text={desc}
                              topBar={topBar}
                            />
                          }
                        </div>
                      )}
                      <div className={st.cont}>
                        {
                          <Highlight
                            abort={!hasCont}
                            query={v.query}
                            text={content}
                            slice={!orinCat}
                            topBar={topBar}
                          />
                        }
                      </div>
                    </div>
                  </div>
                )
              })
            ) : (
              <div className={st.noResult}>暂无搜索结果</div>
            )}
          </div>
        )}
      </div>
    )
  }
}

function Highlight({ abort, query, text, slice, color = "#777", topBar }) {
  const safeText = normalizeSearchText(text)

  if (abort) {
    return <span>{safeText}</span>
  }

  const parts = buildHighlightParts(text, query, { slice, topBar })

  return (
    <span>
      {parts.map((part, index) =>
        part.match ? (
          <b key={index} style={{ color }}>
            {part.text}
          </b>
        ) : (
          <React.Fragment key={index}>{part.text}</React.Fragment>
        )
      )}
    </span>
  )
}
